// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"765c4f77","177":"82b421ba","569":"1c9294b9","640":"9c42be85","773":"ea17e9eb","950":"6e91acb8"}[chunkId] + ".chunk.js";
};